module.exports = __webpack_public_path__ + "img/t2-black.afc952ff.png";